import _implicitStylesheets from "./skillFileViewer.css";
import _implicitScopedStylesheets from "./skillFileViewer.scoped.css?scoped=true";
import _wdsIconInteractive from "wds/iconInteractive";
import _wdsButtonToggle from "wds/buttonToggle";
import _wdsButton from "wds/button";
import _wdsSpinner from "wds/spinner";
import _wdsEmptyState from "wds/emptyState";
import _wdsMarkdown from "wds/markdown";
import _wdsCodeBlock from "wds/codeBlock";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<span class="breadcrumb-segment${0}"${"a0:data-is-last"}${2}>${"t1"}</span>`;
const $fragment2 = parseFragment`<span class="breadcrumb-separator${0}" aria-hidden="true"${2}> / </span>`;
const $fragment3 = parseFragment`<span class="assistive-text${0}" aria-live="polite"${2}>${"t1"}</span>`;
const stc0 = {
  "preview-pane": true
};
const stc1 = {
  classMap: {
    "preview-toolbar": true
  },
  key: 1
};
const stc2 = {
  "breadcrumb-nav": true
};
const stc3 = {
  classMap: {
    "breadcrumb": true
  },
  key: 4
};
const stc4 = {
  "breadcrumb-wrapper": true
};
const stc5 = {
  classMap: {
    "preview-controls": true
  },
  key: 10
};
const stc6 = {
  "raw-button": true
};
const stc7 = {
  classMap: {
    "loading-container": true
  },
  key: 14
};
const stc8 = {
  key: 15
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, c: api_custom_element, k: api_key, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, h: api_element, i: api_iterator, ncls: api_normalize_class_name} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6, _m7} = $ctx;
  return [api_element("div", {
    classMap: stc0,
    attrs: {
      "data-testid": "preview-pane",
      "role": "region",
      "aria-label": $cmp.selectedFileName
    },
    key: 0
  }, [api_element("div", stc1, [$cmp.treeCollapsed ? api_custom_element("wds-icon-interactive", _wdsIconInteractive, {
    props: {
      "icon": "arrow_right",
      "size": "small",
      "ariaLabel": $cmp.packageFilesExpandTree,
      "iconDescription": $cmp.packageFilesExpandTree,
      "name": "show-file-tree"
    },
    key: 2,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.handleToggleTree)),
      "analytics": _m1 || ($ctx._m1 = api_bind($cmp.handleTreeToggleAnalytics))
    }
  }) : null, api_element("nav", {
    classMap: stc2,
    attrs: {
      "aria-label": $cmp.packageFilesHeading
    },
    key: 3
  }, [api_element("ol", stc3, api_iterator($cmp.filePathSegments, function (segment, index) {
    return api_element("li", {
      classMap: stc4,
      key: api_key(5, segment.key)
    }, [api_static_fragment($fragment1, 7, [api_static_part(0, {
      attrs: {
        "data-is-last": segment.isLast
      }
    }, null), api_static_part(1, null, api_dynamic_text(segment.name))]), !segment.isLast ? api_static_fragment($fragment2, 9) : null]);
  }))])]), api_element("div", stc5, [api_custom_element("wds-button-toggle", _wdsButtonToggle, {
    props: {
      "options": $cmp.viewToggleOptions,
      "value": $cmp.effectiveViewMode,
      "ariaLabel": $cmp.viewModeAriaLabel,
      "analyticsNamePrefix": "skill_file_viewer_",
      "disableTransition": $cmp.disableViewToggleTransition
    },
    key: 11,
    on: {
      "select": _m2 || ($ctx._m2 = api_bind($cmp.handleViewToggle)),
      "analytics": _m3 || ($ctx._m3 = api_bind($cmp.handleViewToggleAnalytics))
    }
  }), api_custom_element("wds-button", _wdsButton, {
    classMap: stc6,
    props: {
      "size": "small",
      "variant": "tertiary",
      "label": $cmp.rawLabel,
      "ariaLabel": $cmp.rawLabel,
      "icon": $cmp.rawCopyIcon,
      "iconPlacement": "start",
      "name": "copy-file"
    },
    key: 12,
    on: {
      "click": _m4 || ($ctx._m4 = api_bind($cmp.handleCopyRaw)),
      "analytics": _m5 || ($ctx._m5 = api_bind($cmp.handleCopyAnalytics))
    }
  })]), api_element("div", {
    className: api_normalize_class_name($cmp.previewBodyClass),
    key: 13
  }, [$cmp.isLoading ? api_element("div", stc7, [api_custom_element("wds-spinner", _wdsSpinner, stc8)]) : null, $cmp.hasError ? api_custom_element("wds-empty-state", _wdsEmptyState, {
    props: {
      "role": "alert",
      "imgSrc": "/images/errors/empty_state.svg",
      "imgHeight": "150px",
      "label": $cmp.packageFilesLoadError,
      "labelTypeStyle": "display-7",
      "ctaLabel": $cmp.packageFilesRetry
    },
    key: 16,
    on: {
      "ctaclick": _m6 || ($ctx._m6 = api_bind($cmp.handleRetry))
    }
  }) : null, $cmp.showPreview ? api_custom_element("wds-markdown", _wdsMarkdown, {
    props: {
      "value": $cmp.renderedBody,
      "linkBaseUrl": $cmp.markdownLinkBaseUrl,
      "imageBaseUrl": $cmp.markdownImageBaseUrl,
      "allowedImageRootUrls": $cmp.markdownAllowedImageRootUrls,
      "instrumentLinks": true
    },
    key: 17,
    on: {
      "markdownlinkclick": _m7 || ($ctx._m7 = api_bind($cmp.handleMarkdownLinkClick))
    }
  }) : null, $cmp.showCode ? api_custom_element("wds-code-block", _wdsCodeBlock, {
    props: {
      "code": $cmp.selectedFileBody,
      "language": $cmp.selectedFileExt,
      "label": $cmp.selectedFileName
    },
    key: 18
  }) : null]), api_static_fragment($fragment3, 20, [api_static_part(1, null, api_dynamic_text($cmp.copyStatus))])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-35voim08ci4";
tmpl.legacyStylesheetToken = "undefined-_skillFileViewer";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
